import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLastPathSegment } from 'shared/hooks'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { type InternationalRoutes } from 'pages/settings/pages/compliance/pages/international'
import { ContactForm } from 'pages/settings/pages/compliance/ui/ContactForm/ContactForm'
import styles from './styles.module.scss'

export const ContactInfo = observer(() => {
  const {
    fieldsError,
    deleteErrorValue,
    stepsStore: { stepLoading },
    moveToSecondStep,
    initializeStepsForRoute,
    contactInfoStore: {
      contact,
      phoneInputStore,
      emailLocalError,
      isNextDisabled,
      checkIsEmail,
      setFirstName,
      setLastName,
      setEmail,
      similarityDomainsWarning,
    },
  } = useInternationalStepsContext()
  const lastPathSegment = useLastPathSegment()

  useEffect(() => {
    initializeStepsForRoute(lastPathSegment as InternationalRoutes)
  }, [initializeStepsForRoute, lastPathSegment])

  return (
    <div className={styles.wrap}>
      <PageDescription>
        The individual given the legal authority to act on behalf of this business
      </PageDescription>

      <ContactForm
        emailErrorMessage={(fieldsError && fieldsError['email']) || emailLocalError}
        phoneErrorMessage={fieldsError && fieldsError['phone_number']}
        isErrorBorderEmail={fieldsError ? Boolean(fieldsError['email']) : false}
        contact={contact}
        phoneInputStore={phoneInputStore}
        setFirstName={setFirstName}
        setLastName={setLastName}
        setEmail={setEmail}
        checkIsEmail={checkIsEmail}
        setValueCallback={() => {
          deleteErrorValue('phone_number')
        }}
        similarityDomainsWarning={similarityDomainsWarning}
      />

      <NextButton
        text='Next'
        loading={stepLoading}
        disabled={isNextDisabled || stepLoading}
        onClick={() => moveToSecondStep(lastPathSegment as InternationalRoutes)}
      />
    </div>
  )
})
